module.exports = __webpack_public_path__ + "img/xiaohui5.22cd6488.jpg";